import { ContextTypes } from '../types/statistics/common';

export const STATISTICS_CONTEXTS = [
  {
    id: ContextTypes.WEEK,
    name: 'По неделям',
  },
  {
    id: ContextTypes.MONTH,
    name: 'По месяцам',
  },
  {
    id: ContextTypes.QUARTER,
    name: 'По кварталам',
  },
  {
    id: ContextTypes.YEAR,
    name: 'По годам',
  },
];
